import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import downArrow from "../images/profile-logo.png";
import { Contextone } from "./Context";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import Language from "./Language";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import SideNav from "./SideNav";
import SwitchType from "./SwitchType";

const NewsNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [displayPopUp, setDisplayPopUp] = useState(false);
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [showContent, setShowContent] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const id01Ref = useRef(null);
  const countercontext = useContext(Contextone);
  const isurl = countercontext.isDomain;
  const uid = Cookies.get("userid");
  const history = useHistory();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const barRef = useRef(null)
  const searchRef = useRef(null);

  const logo = countercontext.isLogo

  if(!uid){
    Cookies.set('loc', history.location.pathname)
  }

  useEffect(() => {
    if (isPopupOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [isPopupOpen]);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); 

  const closePopUp = () => {
    setIsPopupOpen(false)
    setDisplayPopUp(false);
    
  };

  const openPopUp = () => {
    setDisplayPopUp(true);
    setIsPopupOpen(true);
    
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        setDisplayPopUp(false);
        sessionStorage.clear();
        history.push("/");
      })
      .catch((error) => {
        console.error("Login Error:", error);
      });
        countercontext.setIsLogOutButton(true);
        localStorage.removeItem("userid");
        Cookies.remove("userid");
        localStorage.removeItem("userPhone");
        setDisplayPopUp(false);
        history.push("/");
        closePopUp();
  };

  let navbarClasses = ["Navbar"];
  if (scrolled) {
    navbarClasses.push("scrolled");
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && searchQuery.trim() !== '') {
      history.push(`/NewsSearch/${searchQuery}`);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [searchQuery]);

  const handleLogoClick = () => {
    setShowDropdown(!showDropdown);
  }

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
    }
     if(searchRef.current && !searchRef.current.contains(event.target)){
      setIsInputVisible(false);
      setSearchQuery('')
     }
  };

  useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);
      };
  }, []);

  const toggleSearchInput = () => {
    if(window.innerWidth <= 768){
      setShowContent(!showContent);
    }
    setIsInputVisible(!isInputVisible);
    
    // setShowContent(!showContent);
  };

  return (
    <>
      <div className={navbarClasses.join(" ")}>
        <div className="NewContainer">
          <Link to={"/"}>
            <img src={logo} alt="Logo" className="navbar-logo" />
          </Link>
        


          
          
          <div className={isurl === 'mahuaplay.ottsnap.in' ? "navbar2-content" : "navbar-content"}>
          <div className="search-container" ref={searchRef}>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search"
              className={`search-input ${isInputVisible ? 'visible' : ''}`}
            />
            <div className="search-button" onClick={toggleSearchInput}>
              <FontAwesomeIcon icon={faMagnifyingGlass} style={{ height: '18px' }} />
            </div>
          </div>
          {/* <Language/>  */}
          {showContent &&<>
            {uid ? (
              <>
                <div className="dropdown" ref={dropdownRef}>
            <img
                src={downArrow}
                alt="Toggle Dropdown"
                className="dropdown-toggle"
                style={{
                    marginBottom: "25px",
                    cursor: "pointer",
                    marginRight: "38px",
                    width: "25px",
                }}
                onClick={handleLogoClick}
            />
            {showDropdown && (
                <div className={`dropdown-menu ${showDropdown ? 'show' : ''}`}>
                    <NavLink to={"/Profile"} className="dropdown-item" activeClassName="active" onClick={handleLogoClick}>
                        Profile
                    </NavLink>
                    <div
                        onClick={openPopUp}
                        className="dropdown-item"
                        style={{ cursor: "pointer" }}
                    >
                        Logout
                    </div>
                </div>
            )}
        </div>
              </>
            ) : (
              !uid&& (
                <Link to={"/NewLogin"} className= 'logButton'>
                  <button
                    type="button"
                    onClick={() => countercontext.setName(true)}
                    className="logbtn"
                  >
                    Login
                  </button>
                </Link>
              )
            )}
            
            {isurl === 'mahuaplay.ottsnap.in' && <SwitchType />}
          
          </>}
          </div>
        </div>
      </div>

      {displayPopUp && (
        <div>
        <div className={`modal ${isPopupOpen ? 'show' : ''}`} ref={id01Ref}>
          <div className="container">
            <p>Are you sure you want to Logout?</p>
  
            <div className="clearfix">
              <button type="button" onClick={closePopUp} className="cancelbtn">
                No
              </button>
              <button
                type="button"
                onClick={handleLogout}
                className="removebtn"
              >
                Sure
              </button>
            </div>
          </div>
        </div>
        {isPopupOpen && <div className="backdrop" onClick={closePopUp} />}
      </div>
      )}
    </>
  );
};

export default NewsNavbar;
